import { combineReducers } from 'redux'
import firstScreenReducer from './stores/firstScreen/firstScreenReducer'
import orderScreenReducer from './stores/OrderScreen/orderScreenReducer'
import cardPhotoReducer from './stores/CardPhoto/cardPhotoReducer'
import mobileExchangerReducer from './stores/MobileExchanger/mobileExchangerReducer'
import mobileExchangerOrderScreenReducer from './stores/MobileExchangerOrder/orderScreenReducer'
import mobileSellReducer from './stores/MobileSell/MobileSellReducer'
import mobileBuyReducer from './stores/MobileBuy/MobileBuyReducer'
import modalReducer from './stores/ModalStore/modalReducer'
import modalScreenReducer from './stores/ScreenModalStore/modalScreenReducer'

export default combineReducers({
    firstScreen: firstScreenReducer,
    orderScreen: orderScreenReducer,
    cardPhoto: cardPhotoReducer,
    mobileExchanger: mobileExchangerReducer,
    mobileExchangerOrder: mobileExchangerOrderScreenReducer,
    mobileSell: mobileSellReducer,
    mobileBuy: mobileBuyReducer,
    modalStore: modalReducer,
    modalScreenStore: modalScreenReducer

})
